import React, { useState, useEffect } from "react";

/** Must match backend Config.TRIAL_DURATION_DAYS (default 1). */
const TRIAL_DURATION_DAYS = 1;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

const TrialBanner = ({ trialStartDate, trialExpired, isSignedIn, hasSubscription, isSuperUser, onSubscribe, isCheckoutLoading, isChatActive }) => {
    const [bannerProps, setBannerProps] = useState(null);

    useEffect(() => {
        if (isSuperUser && isSignedIn) {
            setBannerProps({
                type: "super",
                message: "Optimal Solutions Employee",
                badgeText: "Pro Plan",
            });
            return;
        }

        const calculateTime = () => {
            if (!isSignedIn || hasSubscription || !trialStartDate) {
                setBannerProps(null);
                return;
            }

            if (trialExpired) {
                setBannerProps({
                    type: "trial",
                    message: "Your free trial has expired",
                    buttonText: "Upgrade now to continue",
                    isExpired: true,
                });
                return;
            }

            const start = new Date(trialStartDate);
            const end = new Date(start.getTime() + TRIAL_DURATION_DAYS * MS_PER_DAY);
            const now = new Date();

            const remainingTimeMs = end - now;

            if (remainingTimeMs <= 0) {
                setBannerProps({
                    type: "trial",
                    message: "Your free trial has expired",
                    buttonText: "Upgrade now to continue",
                    isExpired: true,
                });
                return;
            }

            let remainingDays = Math.ceil(remainingTimeMs / MS_PER_DAY);
            if (remainingDays > TRIAL_DURATION_DAYS) remainingDays = TRIAL_DURATION_DAYS;

            setBannerProps({
                type: "trial",
                message: remainingDays === 1
                    ? "Your free trial ends today"
                    : `Your Trial Ends in ${remainingDays} days`,
                buttonText: "Upgrade now",
                isExpired: false,
            });
        };

        calculateTime();

        const interval = setInterval(calculateTime, 60 * 60 * 1000);
        return () => clearInterval(interval);
    }, [trialStartDate, trialExpired, isSignedIn, hasSubscription, isSuperUser]);

    if (!bannerProps) {
        return null;
    }

    if (bannerProps.type === "super") {
        return (
            <div className={`trial-banner-container ${isChatActive ? 'in-chat' : ''}`}>
                <div className="trial-banner-pill super-user-pill">
                    <span className="super-user-star">★</span>
                    <span>{bannerProps.message}</span>
                    <span className="bullet">•</span>
                    <span className="super-user-badge">{bannerProps.badgeText}</span>
                </div>
            </div>
        );
    }

    return (
        <div className={`trial-banner-container ${isChatActive ? 'in-chat' : ''}`}>
            <div className="trial-banner-pill">
                <span>{bannerProps.message}</span>
                <span className="bullet">•</span>
                <button
                    onClick={onSubscribe}
                    disabled={isCheckoutLoading}
                    className="trial-banner-btn"
                >
                    {isCheckoutLoading ? "Loading..." : bannerProps.buttonText}
                </button>
            </div>
        </div>
    );
};

export default TrialBanner;
